namespace TabAurous.Common {
    export namespace GiftVoucherTransactionsSelectService {
        export const baseUrl = 'Common/GiftVoucherTransactionsSelect';

        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<GiftVoucherTransactionsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Common/GiftVoucherTransactionsSelect/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>GiftVoucherTransactionsSelectService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
